import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 100,
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  const colors = ['#FF0000', '#FF8800', '#FFDD00', '#00DD00', '#0088FF', '#8800FF'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'border-b-4 border-black' : ''}`} data-id="element-78">
      <div className="max-w-7xl mx-auto px-6 py-3" data-id="element-79">
        <div className="flex justify-between items-center" data-id="element-80">
          <motion.div className="flex items-center gap-4" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} data-id="element-81">
            <div className="relative hidden md:block" data-id="element-82">
              <motion.div className="w-12 h-12 overflow-hidden border-4 border-black relative z-10" style={{
              borderRadius: '63% 37% 54% 46% / 55% 48% 52% 45%'
            }} whileHover={{
              scale: 1.05,
              rotate: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-83">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6dGwRtaBmWA7zBaRmUQdZN/headshot.jpg" alt="Founder" className="w-full h-full object-cover" data-id="element-84" />
              </motion.div>
              <motion.div className="absolute -top-1 -right-1 text-yellow-400 text-sm" animate={{
              rotate: [0, 360],
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-85">
                ✦
              </motion.div>
            </div>
            <div className="flex items-center gap-2" data-id="element-86">
              <div className="flex gap-1" data-id="element-87">
                {['#FF0000', '#FF8800', '#FFDD00', '#00DD00', '#0088FF', '#8800FF'].map((color, i) => <div key={i} className="w-1.5 h-6" style={{
                backgroundColor: color
              }} data-id="element-88" />)}
              </div>
              <h1 className="text-xl font-bold tracking-tight" data-id="element-89">Dunja builds</h1>
            </div>
          </motion.div>
          <nav className="hidden md:flex space-x-6" data-id="element-90">
            {[{
            id: 'profile',
            label: 'ABOUT',
            color: '#FF0000'
          }, {
            id: 'problem',
            label: 'PROBLEM',
            color: '#FF8800'
          }, {
            id: 'vision',
            label: 'VISION',
            color: '#FFDD00'
          }, {
            id: 'financials',
            label: 'NUMBERS',
            color: '#00DD00'
          }, {
            id: 'why-me',
            label: 'WHY ME',
            color: '#0088FF'
          }, {
            id: 'ask',
            label: 'THE ASK',
            color: '#8800FF'
          }].map(item => <motion.button key={item.id} className="text-sm font-bold tracking-wide hover:opacity-70 transition-opacity" onClick={() => scrollToSection(item.id)} whileHover={{
            y: -2
          }} data-id="element-91">
                {item.label}
              </motion.button>)}
          </nav>
          <div className="md:hidden" data-id="element-92">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2" data-id="element-93">
              {mobileMenuOpen ? <XIcon size={24} data-id="element-94" /> : <MenuIcon size={24} data-id="element-95" />}
            </button>
          </div>
        </div>
      </div>
      {mobileMenuOpen && <motion.div className="md:hidden bg-white border-t-4 border-black" initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} data-id="element-96">
          <div className="px-6 py-4 space-y-2" data-id="element-97">
            {[{
          id: 'profile',
          label: 'ABOUT'
        }, {
          id: 'problem',
          label: 'PROBLEM'
        }, {
          id: 'vision',
          label: 'VISION'
        }, {
          id: 'financials',
          label: 'NUMBERS'
        }, {
          id: 'why-me',
          label: 'WHY ME'
        }, {
          id: 'ask',
          label: 'THE ASK'
        }].map(item => <button key={item.id} className="block w-full text-left px-4 py-2 text-sm font-bold hover:bg-gray-100" onClick={() => scrollToSection(item.id)} data-id="element-98">
                {item.label}
              </button>)}
          </div>
        </motion.div>}
    </header>;
}